import gql from "graphql-tag";

export const CRITICAL_TASKS_ENTITY_FRAGMENT = gql`
  fragment CriticalTasksEntity on CriticalTask {
    id
    name
    position
  }
`;
